/**
 * Lightweight consent state shared across the app.
 * - Stored in localStorage so the visitor's choice persists.
 * - Exposes window event `l2m:consent-change` so GA / future Meta Pixel can react.
 */
const KEY = "l2m_consent_v1";

export const CONSENT_STATUS = {
  UNSET: "unset",
  ACCEPTED: "accepted",
  DECLINED: "declined",
};

export function getConsent() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return CONSENT_STATUS.UNSET;
    const parsed = JSON.parse(raw);
    return parsed?.status || CONSENT_STATUS.UNSET;
  } catch {
    return CONSENT_STATUS.UNSET;
  }
}

export function setConsent(status) {
  try {
    localStorage.setItem(
      KEY,
      JSON.stringify({ status, ts: new Date().toISOString() })
    );
  } catch {
    // ignore storage errors (private mode, etc.)
  }
  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent("l2m:consent-change", { detail: { status } })
    );
  }
}

export function clearConsent() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent("l2m:consent-change", {
        detail: { status: CONSENT_STATUS.UNSET },
      })
    );
  }
}

export function onConsentChange(handler) {
  if (typeof window === "undefined") return () => {};
  window.addEventListener("l2m:consent-change", handler);
  return () => window.removeEventListener("l2m:consent-change", handler);
}
